export default __webpack_public_path__ + "static/media/step-c-3.c63f6857.png";